import { StatusCodes } from 'http-status-codes';

export class FetchError extends Error {
  public readonly status: number;

  public readonly info: any;

  constructor(message: string, status: number, info: any) {
    super(message);
    this.status = status;
    this.info = info;
  }

  isServerError(): boolean {
    return this.status >= StatusCodes.INTERNAL_SERVER_ERROR;
  }

  isNotFoundError(): boolean {
    return this.status === StatusCodes.NOT_FOUND;
  }

  isClientError(): boolean {
    return this.status >= StatusCodes.BAD_REQUEST && this.status < StatusCodes.INTERNAL_SERVER_ERROR;
  }
}
